/**
 * Posts store media either as plain URL strings or as `{ url, type }` objects
 * depending on where they were created. This normalises both shapes so every
 * card can render a real thumbnail instead of a broken image.
 */
export function mediaUrls(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.flatMap((v) => {
    if (typeof v === "string") return v ? [v] : [];
    if (v && typeof v === "object") {
      const url = (v as { url?: unknown }).url;
      if (typeof url === "string" && url) return [url];
    }
    return [];
  });
}

export const isVideoUrl = (url: string) => /\.(mp4|webm|mov|m3u8)$/i.test(url) || /\.(mp4|webm|mov|m3u8)\?/i.test(url) || url.endsWith("#video");
